import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { Col, Row } from 'react-flexbox-grid';
import { Button, SecondaryNavigation, SecondaryNavigationTitle, Wrapper } from '@wfp/ui';
import { iconChevronLeft, iconChevronRight } from '@wfp/icons';

import { EditionSummary } from './EditionSummary';
import { HomeActions } from './HomeActions';
import { useCurrentDoc, useCurrentEdition, useDedobUser, useDocId } from '../../hooks/home';
import { editions, getNextEditionDef, getUserOwnedSections, userCanCreateRevision } from '../../restapi/document';
import { unlockSections } from '../../restapi/section';
import { formatDate } from '../../utils';
import { DocCalendar } from './DocCalendar';


function addDays(d: Date, days: number) {
	const r = new Date(d);
	r.setDate(r.getDate() + days);
	return r;
}

export function PageHome() {
	const docId = useDocId();
	const user = useDedobUser();
	const docData = useCurrentDoc();
	const queryClient = useQueryClient();
	useEffect(() => {
		const userLockedSections = getUserOwnedSections(docData, user);
		if (userLockedSections.length) {
			unlockSections(userLockedSections).then(
				() => queryClient.invalidateQueries('doc'),
			);
		}
	}, [queryClient, user, docData]);
	const currentEdition = useCurrentEdition();

	const d = new Date(docId);  // date assumed to be in UTC
	const prev = addDays(d, -1).toISOString().substring(0, 10);  // yyyy-mm-dd
	const next = addDays(d, 1).toISOString().substring(0, 10);  // yyyy-mm-dd

	// which is the next edition to be created (if current one is published)
	const canCreateRev = user && userCanCreateRevision(user);
	const nextEditionDef = (docData && canCreateRev) ? getNextEditionDef(docData) : undefined;

	return (<>
		<SecondaryNavigation>
			<SecondaryNavigationTitle>DOB for:
				<Link to={'/' + prev}>
					<Button className="reset-font-size" kind="ghost" icon={iconChevronLeft} iconDescription=" "/>
				</Link>
				{formatDate(d)}
				<Link to={'/' + next}>
					<Button className="reset-font-size" kind="ghost" icon={iconChevronRight} iconDescription=" "/>
				</Link>
				<DocCalendar key={docId}/>
			</SecondaryNavigationTitle>
		</SecondaryNavigation>

		<Wrapper background="lighter" pageWidth="lg" spacing="md">
			{currentEdition && <HomeActions/>}
			<Row>
				{docData?.editionSet &&
					editions.map((d, i) =>
						<Col xs={12} md={6} lg={4} key={d.name}>
							<EditionSummary
								def={d}
								edition={docData.editionSet.find(e => e.name === d.name)}
								nextRevision={nextEditionDef?.name}
							/>
						</Col>,
					)}
			</Row>
		</Wrapper>
	</>);
}